import { useState, useEffect } from "react"

const useStockModulesDB = (firebase) => {
  const [stockModules, setStockModules] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!firebase) {
      setIsLoading(false)
      return
    }

    let isMounted = true

    const fetchStockModules = async () => {
      try {
        const res = await firebase.getAllStockModules()
        if (isMounted) {
          setStockModules(res.data)
        }
      } catch (err) {
        if (isMounted) {
          setError(err)
        }
      } finally {
        if (isMounted) {
          setIsLoading(false)
        }
      }
    }

    fetchStockModules()

    return () => {
      isMounted = false
    }
  }, [firebase])

  return { stockModules, isLoading, error }
}

export default useStockModulesDB